import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Google Analytics Measurement ID
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX'; // 実際のMeasurement IDに置き換えてください

// Google Analyticsスクリプトを動的に読み込む
export const loadGoogleAnalytics = () => {
  if (typeof window === 'undefined') return;

  // すでに読み込まれている場合はスキップ
  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) {
    return;
  }

  // Google Analyticsスクリプトを追加
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // gtag関数を初期化
  script.onload = () => {
    if (typeof window !== 'undefined' && !(window as any).gtag) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).gtag = function gtag() {
        (window as any).dataLayer.push(arguments);
      };
      (window as any).gtag('js', new Date());
      (window as any).gtag('config', GA_MEASUREMENT_ID);
    }
  };
};

// ページビューを送信
export const sendPageView = (path: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

// イベントを送信
export const sendEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', eventName, eventParams);
  }
};

// Analytics コンポーネント
const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Google Analyticsを読み込む
    loadGoogleAnalytics();
  }, []);

  useEffect(() => {
    // ページ遷移時にページビューを送信
    sendPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

export default Analytics;
